import { render, staticRenderFns } from "./ThemeEditor.vue?vue&type=template&id=7810f568&scoped=true"
import script from "./ThemeEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThemeEditor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ThemeEditor.vue?vue&type=style&index=0&id=7810f568&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7810f568",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7810f568')) {
      api.createRecord('7810f568', component.options)
    } else {
      api.reload('7810f568', component.options)
    }
    module.hot.accept("./ThemeEditor.vue?vue&type=template&id=7810f568&scoped=true", function () {
      api.rerender('7810f568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/ThemeEditor.vue"
export default component.exports